// import {  } from "../constants";

const initialState = {};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default profileReducer;
